import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const TelaCarregando = ({ texto = "Carregando…" }) => (
  <div className="grid min-h-[60vh] place-items-center">
    <div className="flex flex-col items-center gap-3 text-slate-500">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <span className="text-sm">{texto}</span>
    </div>
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, carregando, isAdmin } = useAuth();
  const location = useLocation();

  if (carregando) return <TelaCarregando texto="Verificando acesso…" />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/consulta" replace />;
  return children;
};
